import { actionTypes } from "./pinnedTypes";

const initialState: pinnedStateType = {
  pinnedIds: [],
  pinnedUsers: [],
  step: 28,
  isLoadingPinned: false
};

type pinnedStateType = {
  pinnedIds: Array<string>;
  pinnedUsers: Array<any>;
  step: number;
  isLoadingPinned: boolean;
};

const pinnedReducer = (state = initialState, { type, payload }: any) => {
  switch (type) {
    case actionTypes.SET_PINNED_IDS:
      return {
        ...state,
        pinnedIds: payload,
      };
    case actionTypes.SET_PINNED_USERS:
      return {
        ...state,
        pinnedUsers: payload,
      };
    case actionTypes.SET_PINNED_USERS_BY_PAGE:
      return {
        ...state,
        pinnedUsers: [...state.pinnedUsers, ...payload],
      };
    case actionTypes.SET_PINNED_LOADING:
      return {
        ...state,
        isLoadingPinned: payload
      };
    case actionTypes.RESET_PINNED:
      return {
        ...state,
        pinnedIds: [],
        pinnedUsers: [],
        isLoadingPinned: true,
      };
    default:
      return state;
  }
};

export default pinnedReducer;
